const MAX_FILE_SIZE = 1073741824; // 1gb

export const IMAGE_MIME_TYPES = ["image/*"];
export const VIDEO_MIME_TYPES = ["video/*"];
export const GIF_MIME_TYPE = "image/gif";

export const validateMimeType = (files: FileList, acceptMimeTypes: string[]) => {
  if (files.length === 0) {
    return false;
  }

  if (acceptMimeTypes.length === 0 || acceptMimeTypes[0] === "*") {
    return true;
  }

  let isValid = true;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const [base] = file.type.split("/");

    if (
      acceptMimeTypes.indexOf(file.type) === -1 &&
      acceptMimeTypes.indexOf(`${base}/*`) === -1
    ) {
      isValid = false;
    }
  }

  return isValid;
};

export const validateSize = (files: FileList) => {
  if (files.length === 0) {
    return false;
  }

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (file.size > MAX_FILE_SIZE) {
      return false;
    }
  }

  return true;
};
